import {
  IComments,
  ICommentsTypes,
  ICommentParams,
  IUpdateCommentParams,
  IDeleteCommentParams,
} from './types';

export function getCommentsRequest(processInstanceId: string | null) {
  return {
    type: ICommentsTypes.GET_TASK_COMMENTS_REQUEST,
    payload: { processInstanceId },
  };
}
export function getCommentsSuccess(comments: Array<IComments>) {
  return {
    type: ICommentsTypes.GET_TASK_COMMENTS_SUCCESS,
    payload: { comments },
  };
}
export function getCommentsFailure() {
  return {
    type: ICommentsTypes.GET_TASK_COMMENTS_FAILURE,
  };
}

export function commentTaskRequest({
  processInstanceId,
  taskId,
  taskName,
  userId,
  userFirstName,
  userLastName,
  userAvatar,
  content,
}: ICommentParams) {
  return {
    type: ICommentsTypes.COMMENT_TASK_COMMENTS_REQUEST,
    payload: {
      processInstanceId,
      taskId,
      taskName,
      userId,
      userFirstName,
      userLastName,
      userAvatar,
      content,
    },
  };
}
export function commentTaskSuccess(comments: Array<IComments>) {
  return {
    type: ICommentsTypes.COMMENT_TASK_COMMENTS_SUCCESS,
    payload: { comments },
  };
}
export function commentTaskFailure() {
  return {
    type: ICommentsTypes.COMMENT_TASK_COMMENTS_FAILURE,
  };
}

export function updateTaskCommentRequest({
  id,
  processInstanceId,
  taskId,
  content,
}: IUpdateCommentParams) {
  return {
    type: ICommentsTypes.UPDATE_TASK_COMMENT_REQUEST,
    payload: { id, processInstanceId, taskId, content },
  };
}
export function updateTaskCommentSuccess(comments: Array<IComments>) {
  return {
    type: ICommentsTypes.UPDATE_TASK_COMMENT_SUCCESS,
    payload: { comments },
  };
}
export function updateTaskCommentFailure() {
  return {
    type: ICommentsTypes.UPDATE_TASK_COMMENT_FAILURE,
  };
}

export function deleteTaskCommentRequest({
  id,
  processInstanceId,
  taskId,
}: IDeleteCommentParams) {
  return {
    type: ICommentsTypes.DELETE_TASK_COMMENT_REQUEST,
    payload: { id, processInstanceId, taskId },
  };
}
export function deleteTaskCommentSuccess(comments: Array<IComments>) {
  return {
    type: ICommentsTypes.DELETE_TASK_COMMENT_SUCCESS,
    payload: { comments },
  };
}
export function deleteTaskCommentFailure() {
  return {
    type: ICommentsTypes.DELETE_TASK_COMMENT_FAILURE,
  };
}
